import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getPaymentStatus } from "../utils/paymentApi";
import { Spinner } from "./components/Spinner";

export const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const [verifying, setVerifying] = useState(true);

  useEffect(() => {
    const sessionId = searchParams.get("session_id");

    if (!sessionId) {
      setError("No session ID found. Please try again.");
      setVerifying(false);
      return;
    }

    const verifyPayment = async () => {
      try {
        const result = await getPaymentStatus(sessionId);
        if (result.status === "paid") {
          navigate("/thankyou", { replace: true });
        } else {
          setError(`Payment not confirmed yet. Status: ${result.status}. Please wait or contact support.`);
          setVerifying(false);
        }
      } catch (e: any) {
        console.error("Payment verification failed", e);
        setError("Could not verify payment. Please contact support.");
        setVerifying(false);
      }
    };

    verifyPayment();
  }, [searchParams, navigate]);

  if (verifying) {
    return (
      <div className="flex flex-col items-center justify-center px-6 mt-12">
        <Spinner />
        <p className="mt-4 text-grayish">Verifying your payment...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center px-6 mt-12">
        <h2 className="text-xl font-bold text-red-500">Payment Issue</h2>
        <p className="text-center mt-4 text-grayish">{error}</p>
        <button
          className="mt-6 text-primary underline"
          onClick={() => navigate("/")}
        >
          Go back to home
        </button>
      </div>
    );
  }

  return null;
};

